//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Col, Row, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Locations from './locations';
import PropertyConditions from './property-conditions';
import MyPlacesAutocomplete from '../../../util/my-places-autocomplete';
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const lotSizeUnitEnum = [{value:'SQUARE_FEET',label:'Square Feet'}];
const collectionTypeEnum = [{value:'ONSITE',label:'On Site'},{value:'VIRTUAL',label:'Virtual'},{value:'3D_SCAN',label:'3D Scan'}];
const propertyTypeEnum = [{value:'SF',label:'Single Family'},{value:'CONDO',label:'Condo'}];
const propertyOccupancyEnum = [{value:'True',label:'Occupied'},{value:'False',label:'Vacant'}];
const states = [
  {key:'Alabama',value:'Alabama'},{key:'Alaska',value:'Alaska'},{key:'Arizona',value:'Arizona'},{key:'Arkansas',value:'Arkansas'},{key:'California',value:'California'},{key:'Colorado',value:'Colorado'},{key:'Connecticut',value:'Connecticut'},{key:'Delaware',value:'Delaware'},{key:'Florida',value:'Florida'},{key:'Georgia',value:'Georgia'},{key:'Hawaii',value:'Hawaii'},{key:'Idaho',value:'Idaho'},{key:'Illinois',value:'Illinois'},{key:'Indiana',value:'Indiana'},{key:'Iowa',value:'Iowa'},{key:'Kansas',value:'Kansas'},{key:'Kentucky',value:'Kentucky'},{key:'Louisiana',value:'Louisiana'},{key:'Maine',value:'Maine'},{key:'Maryland',value:'Maryland'},{key:'Massachusetts',value:'Massachusetts'},{key:'Michigan',value:'Michigan'},{key:'Minnesota',value:'Minnesota'},{key:'Mississippi',value:'Mississippi'},{key:'Missouri',value:'Missouri'},{key:'Montana',value:'Montana'},{key:'Nebraska',value:'Nebraska'},{key:'Nevada',value:'Nevada'},{key:'New Hampshire',value:'New Hampshire'},{key:'New Jersey',value:'New Jersey'},{key:'New Mexico',value:'New Mexico'},{key:'New York',value:'New York'},{key:'North Carolina',value:'North Carolina'},{key:'North Dakota',value:'North Dakota'},{key:'Ohio',value:'Ohio'},{key:'Oklahoma',value:'Oklahoma'},{key:'Oregon',value:'Oregon'},{key:'Pennsylvania',value:'Pennsylvania'},{key:'Rhode Island',value:'Rhode Island'},{key:'South Carolina',value:'South Carolina'},{key:'South Dakota',value:'South Dakota'},{key:'Tennessee',value:'Tennessee'},{key:'Texas',value:'Texas'},{key:'Utah',value:'Utah'},{key:'Vermont',value:'Vermont'},{key:'Virgin Islands',value:'Virgin Islands'},{key:'Virginia',value:'Virginia'},{key:'Washington',value:'Washington'},{key:'Washington DC',value:'Washington DC'},{key:'West Virginia',value:'West Virginia'},{key:'Wisconsin',value:'Wisconsin'},{key:'Wyoming',value:'Wyoming'}
];
const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const StepReportPropertyInfo  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const numberOnly= (e) => {
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key);
    if (!isControlKey && e.key.match(/[^0-9]/)) {
      e.preventDefault();
    }
  };
  
  const updateField = (field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    switch(field){
      case 'collectionType':
        newUPD.collectionType = value;
        break;
      case 'caseFileID':
        newUPD.caseFileID = value;
        break;
      case 'lpaID':
        newUPD.lpaID = value;
        break;
      case 'pdaHyperlink':
        newUPD.pdaHyperlink = value;
        break;
      case 'street':
        newUPD.property.street = value;
        break;
      case 'propertyType':
        newUPD.property.propertyType = value;
        //reset the building info as many fields rely on property type
        newUPD.property.buildings = [{imageStructureFront:[], imageStructureRear:[], imageStructureLeft:[], imageStructureRight:[],imageBuildingFront:[], imageBuildingRear:[], imageBuildingLeft:[], imageBuildingRight:[],imageDwellingFront:[], imageDwellingRear:[], imageDwellingLeft:[], imageDwellingRight:[], condoCarStorages:[],exteriorDeficiencies:[],exteriorUpdates:[], units:[{imageFloorPlan:[], unitView:{views:[]}, unitFeatures:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{ gla:[],belowGradeExits:[], atticAccess:[], rooms:[{imageRoom:[], imageKitchen:[], imageLivingroom:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]}]}];
        break;
      case 'propertyOccupied':
        newUPD.property.propertyOccupied = value;
        break;
      case 'streetAddress':
        newUPD.property.address.streetAddress = value;
        break;
      case 'unitNumber':
        newUPD.property.address.unitNumber = value;
        break;
      case 'city':
        newUPD.property.address.city = value;
        break;
      case 'county':
        newUPD.property.address.county = value;
        break;
      case 'state':
        newUPD.property.address.state = value;
        break;
      case 'postalCode':
        newUPD.property.address.postalCode = value;
        break;
      case 'lotSize':
        newUPD.property.site.lot.lotSize = value;
        break;
      case 'lotSizeUnits':
        newUPD.property.site.lot.lotSizeUnits = value;
        break;
      default:
        newUPD[field] = value;
    }
    console.log(newUPD);
    props.update(newUPD);
  }

  const numberOnlyUpToTen = (e) => {
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key);
    if (!isControlKey && e.key.match(/[^0-9]/)) {
      e.preventDefault();
    }
    else if(!isControlKey && props.upd.caseFileID.length>=10)
      e.preventDefault();
  };

  const googlePlaceOnChange = (address)=>{
    if(address!==props.upd.property.address){

      if(address.indexOf(',')!==-1 && address.length>10){
        geocodeByAddress(address)
          .then(
            results => {
              //always use the first returned result
              let targetResult = results[0];

              let addressComponents = targetResult.address_components;

              let streetNumber = '';
              let route = '';
              let city = '';
              let county = '';
              let state = '';
              let zip = '';

              //go through the address components and grab the street, city, county, state, and zip
              for(let i=0;i<addressComponents.length;i++){
                if(addressComponents[i].types[0]==='street_number')
                  streetNumber = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='route')
                  route = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='locality'&&addressComponents[i].types[1]==='political')
                  city = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_2'&&addressComponents[i].types[1]==='political')
                  county = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_1'&&addressComponents[i].types[1]==='political')
                  state = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='postal_code')
                  zip = addressComponents[i].long_name;
              }

              let street = '';

              if(streetNumber!==''&&route!=='')
                street = streetNumber+' '+route;

              if(street!==''){
                updateField('street', street);
              }
              if(city!=='')
                updateField('city', city);
              if(county!=='')
                updateField('county', county);
              if(state!=='')
                updateField('state', state);
              if(zip!=='')
                updateField('postalCode', zip);
            })
          .catch(
            error => {
              console.log(error);
            }
          );
      }
      else{
        updateField('streetAddress', address);
        updateField('street', address);
      }
    }
  }

  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let target = newUPD[field];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:typeFk, description:description});
                newUPD[field] = target;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateFileDescription = (index, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let target = newUPD[field];
    if(target &&  target[index]){
      target[index].description = description;
    }

    newUPD[field] = target;
    props.update(newUPD);
  }

  const removeFile = (field,index)=>{
    let newUPD = Object.assign({}, props.upd);
    let target = newUPD[field];

    let targetToDelete = target[index];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index, 1);
        newUPD[field] = target;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index, 1);
      newUPD[field] = target;
      props.update(newUPD);
    }

  }


  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  let caseFileID;
  let lpaKey;
  
  if(props.upd.platform==='FNM')
    caseFileID = <Col sm="3">
    <label>Case File ID {generateTooltip('caseFileID', 'Loan identifier produced by Fannie Mae\'s Desktop Underwriter application.')}</label>
    <Input pattern="[0-9]*" onKeyDown={numberOnlyUpToTen} inputMode="numeric" style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={props.upd.caseFileID} onChange={(e)=>updateField('caseFileID', e.target.value)}/>
  </Col>;
  else if(props.upd.platform==='FRE')
    lpaKey = <Col sm="3">
    <label>LPA Key {generateTooltip('lpaID', 'Loan identifier produced by Freddie Mac\'s Loan Product Advisor application.')}</label>
    <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={props.upd.lpaID} onChange={(e)=>updateField('lpaID', e.target.value)}/>
  </Col>;


  let pdaHyperlink;

  let unitNumber = <Col sm="3">
    <label>Unit Number</label>
    <Input autoComplete="new-password" style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={props.upd.property.address.unitNumber} onChange={(e)=>updateField('unitNumber',e.target.value)}/>
  </Col>;


  let unitNumberImage = <Col sm="6">
    <label>Image of Unit Number {generateTooltip('imageUnitNumber', 'Image of the unit number for the property')}</label>
    <br/><br/>
    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, 'imageUnitNumber', 'UNIT_NUMBER', 0)}} className="my-dropzone">
    {
      ({getRootProps, getInputProps}) => (
        <div
          {...getRootProps({
            className: 'my-dropzone',
          })}
        >
          <input {...getInputProps()} />
          <center>Choose files to upload</center>
        </div>
      )
    }
    </Dropzone>
    {
      !props.upd.imageUnitNumber?null:props.upd.imageUnitNumber.map(
        (photo, index)=>{
          return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
            <div>
              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageUnitNumber',index)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
            </div>
            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, 'imageUnitNumber', e.target.value)}/>
            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
          </div>
        }
      )
    }
  </Col>

  //render
  return <div>
    <Card>
      <CardHeader className="header-color">
        Report Info
      </CardHeader>
      <CardBody>
        <Row style={{marginTop:'15px'}}>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Collection Type {generateTooltip('collectionType', 'Indicate how the property data collection was performed.')}</label>
            <MySelect
              type="select"
              required={!props.disabled}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={props.upd.collectionType}
              onChange={(v)=>updateField('collectionType', v)}
              options={collectionTypeEnum}
            />
          </Col>
          {caseFileID}
          {lpaKey}
          {pdaHyperlink}
        </Row>
      </CardBody>
    </Card>
    <br/>
    <Card>
      <CardHeader className="header-color">
        Property Info
      </CardHeader>
      <CardBody>
        <Row style={{marginTop:'15px'}}>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Type</label>
            <MySelect
              type="select"
              required={!props.disabled}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={props.upd.property.propertyType}
              onChange={(v)=>updateField('propertyType', v)}
              options={propertyTypeEnum}
            />
          </Col>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Property Occupancy</label>
            <MySelect
              type="select"
              required={!props.disabled}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={props.upd.property.propertyOccupied}
              onChange={(v)=>updateField('propertyOccupied', v)}
              options={propertyOccupancyEnum}
            />
          </Col>
        </Row>
        <Row style={{marginTop:'15px'}}>
          <Col sm="5">
            <label>{!props.disabled?<font color="red">*</font>:null}Street</label>
            <MyPlacesAutocomplete value={props.upd.property.street} onChange={googlePlaceOnChange} onSelect={googlePlaceOnChange}/>
          </Col>
          {unitNumber}
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}City</label>
            <Input autoComplete="new-password" style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={props.upd.property.address.city} onChange={(e)=>updateField('city',e.target.value)}/>
          </Col>
          <Col sm="4">
            <label>{!props.disabled?<font color="red">*</font>:null}State</label>
            <MySelect
              type="select"
              style={props.disabled?disabledStyling:{}}
              disabled={props.disabled}
              required={!props.disabled}
              value={props.upd.property.address.state}
              onChange={(v)=>updateField('state',v)}
              options={states.map((state)=>{
                return {label:state.value, value:state.value};
              })}
            />
          </Col>
        </Row>
        <Row style={{marginTop:'15px'}}>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}County</label>
            <Input style={props.disabled?disabledStyling:{}} autoComplete="new-password" disabled={props.disabled} required={!props.disabled} type="text" value={props.upd.property.address.county} onChange={(e)=>updateField('county',e.target.value)}/>
          </Col>
          <Col sm="2">
            <label>{!props.disabled?<font color="red">*</font>:null}Zip</label>
            <Input style={props.disabled?disabledStyling:{}} autoComplete="new-password" disabled={props.disabled} required={!props.disabled} type="text" value={props.upd.property.address.postalCode} onChange={(e)=>updateField('postalCode',e.target.value)}/>
          </Col>
        </Row>
        
        {props.upd.property.propertyType==='SF'?<Row>
          <Col sm="3">
            <label>Lot Size</label>
            <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" pattern="[0-9]*" onKeyDown={numberOnly} value={props.upd.property.site.lot.lotSize} onChange={(e)=>updateField('lotSize',e.target.value)}/>
          </Col>
          <Col sm="3">
            <label>{!props.disabled?<font color="red">*</font>:null}Lot Size Unit</label>
            <MySelect
              type="select"
              required={!props.disabled}
              disabled={props.disabled}
              style={props.disabled?disabledStyling:{}}
              value={props.upd.property.site.lot.lotSizeUnits}
              onChange={(v)=>updateField('lotSizeUnits', v)}
              options={lotSizeUnitEnum}
            />
          </Col>
        </Row>:null}
        <br/>
        <div className="my-divider"/>
        <Row>
          <Col sm="6">
            <label><font color="red">*</font>Image of Street Address {generateTooltip('imageStreetNumber', 'Image of street address number, such as number on mailbox or house.')}</label>
            <br/>
            <input
              tabIndex={-1}
              autoComplete="off"
              style={{ opacity: 0, height: 0, width:0 }}
              value={props.upd.imageStreetNumber&&props.upd.imageStreetNumber.length>0?" ":""}
              required={!props.disabled}
            />
            <div>
              <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, 'imageStreetNumber', 'STREET_ADDRESS', 0)}} className="my-dropzone">
              {
                ({getRootProps, getInputProps}) => (
                  <div
                    {...getRootProps({
                      className: 'my-dropzone',
                    })}
                  >
                    <input {...getInputProps()} />
                    <center>Choose files to upload</center>
                  </div>
                )
              }
              </Dropzone>
              {
                !props.upd.imageStreetNumber?null:props.upd.imageStreetNumber.map(
                  (photo, index)=>{
                    return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                      <div>
                        <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageStreetNumber',index)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                      </div>
                      <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                      {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, 'imageStreetNumber', e.target.value)}/>
                      <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                    </div>
                  }
                )
              }
            </div>
          </Col>
          {unitNumberImage}
        </Row>
        <br/>
        <Row>
          <Col sm="6">
            <label><font color="red">*</font>Image of street to the Left {generateTooltip('imageStreetLeft', 'Image of subject\'s road/street to the left. Left as facing the subject property from the street.')}</label>
            <br/>
            <input
              tabIndex={-1}
              autoComplete="off"
              style={{ opacity: 0, height: 0, width:0 }}
              value={props.upd.imageStreetLeft&&props.upd.imageStreetLeft.length>0?" ":""}
              required={!props.disabled}
            />
            <div>
              <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, 'imageStreetLeft', 'STREET_LEFT', 0)}} className="my-dropzone">
              {
                ({getRootProps, getInputProps}) => (
                  <div
                    {...getRootProps({
                      className: 'my-dropzone',
                    })}
                  >
                    <input {...getInputProps()} />
                    <center>Choose files to upload</center>
                  </div>
                )
              }
              </Dropzone>
              {
                !props.upd.imageStreetLeft?null:props.upd.imageStreetLeft.map(
                  (photo, index)=>{
                    return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                      <div>
                        <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageStreetLeft',index)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                      </div>
                      <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                      {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, 'imageStreetLeft', e.target.value)}/>
                      <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                    </div>
                  }
                )
              }
            </div>
          </Col>
          <Col sm="6">
            <label><font color="red">*</font>Image of street to the Right {generateTooltip('imageStreetRight', 'Image of subject\'s road/street to the right. Right as facing the subject property from the street.')}</label>
            <br/>
            <input
              tabIndex={-1}
              autoComplete="off"
              style={{ opacity: 0, height: 0, width:0 }}
              value={props.upd.imageStreetRight&&props.upd.imageStreetRight.length>0?" ":""}
              required={!props.disabled}
            />
            <div>
              <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, 'imageStreetRight', 'STREET_RIGHT', 0)}} className="my-dropzone">
              {
                ({getRootProps, getInputProps}) => (
                  <div
                    {...getRootProps({
                      className: 'my-dropzone',
                    })}
                  >
                    <input {...getInputProps()} />
                    <center>Choose files to upload</center>
                  </div>
                )
              }
              </Dropzone>
              {
                !props.upd.imageStreetRight?null:props.upd.imageStreetRight.map(
                  (photo, index)=>{
                    return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                      <div>
                        <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageStreetRight',index)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                      </div>
                      <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                      {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, 'imageStreetRight', e.target.value)}/>
                      <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                    </div>
                  }
                )
              }
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
    <br/>
    <Card>
      <CardHeader className="header-color">
        Property Location
      </CardHeader>
      <CardBody>
        <Locations {...props}/>
      </CardBody>
    </Card>
    <br/>
    <Card>
      <CardHeader className="header-color">
        Property Conditions
      </CardHeader>
      <CardBody>
        <PropertyConditions {...props}/>
      </CardBody>
    </Card>
  </div>
}


export default StepReportPropertyInfo;